/**
  * Dynamic viewport for different screen size
  * @since 2019-05-31
  */
  window.addEventListener('DOMContentLoaded', function() {
  if (window.screen.width < 768) {
    var vp = document.getElementById('viewport');
    vp.setAttribute('content', 'width=768, initial-scale=1, user-scalable=yes, shring-to-fit=yes');
  }
});